import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { SuiNotificationGroup, SuiPopover } from '@splashthat/sui';

import { closeNotification, getAllNotifications } from '../modules';

function NotificationWrapper(props) {
    return (
        <SuiPopover open={props.notifications.length > 0} useClickCatcher={false} positionPopoverToAnchor={false}>
            <SuiNotificationGroup {...props} />
        </SuiPopover>
    );
}

NotificationWrapper.propTypes = {
    notifications: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
    notifications: getAllNotifications(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            closeNotification,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(NotificationWrapper);
